import { Quote } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";
import { TESTIMONIALS } from "@/data/content";
import { Reveal } from "./Reveal";

export const Testimonials = () => (
  <section
    data-testid={TESTIDS.testimonials.section}
    className="py-24 lg:py-32 px-5 sm:px-8 bg-white"
  >
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <h2 className="font-display font-700 text-4xl sm:text-5xl tracking-tighter text-ink max-w-xl">
          Zaufały mi setki nauczycieli i rodziców
        </h2>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-7">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="h-full rounded-[2rem] bg-cream border border-ink/5 p-8 flex flex-col">
              <Quote size={28} className="text-violet-soft" fill="currentColor" />
              <p className="mt-5 text-lg text-ink/75 leading-relaxed flex-1">"{t.quote}"</p>
              <div className="mt-6 flex items-center gap-3">
                <div className="grid place-items-center h-11 w-11 rounded-full bg-violet text-white font-600">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-600 text-ink">{t.name}</div>
                  <div className="text-sm text-ink/45">{t.role}</div>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
